import { RouteConfig } from 'vue-router';
const AuthModule = () =>
  import(/* webpackChunkName: 'auth' */ '@/modules/auth/AuthModule.vue');
const LoginPage = () =>
  import(/* webpackChunkName: 'auth' */ '@/modules/auth/pages/LoginPage.vue');
const ResetPasswordPage = () =>
  import(
    /* webpackChunkName: 'auth' */ '@/modules/auth/pages/ResetPasswordPage.vue'
  );
const ForgotPasswordPage = () =>
  import('@/modules/auth/pages/ForgotPasswordPage.vue');
const ImpersonationPage = () =>
  import(
    /* webpackChunkName: 'admin' */ '@/modules/auth/pages/ImpersonationPage.vue'
  );
const SignupPage = () => import('@/modules/auth/pages/SignupPage.vue');
const TwoFactorAuthPage = () =>
  import('@/modules/auth/pages/TwoFactorAuthPage.vue');
const OneTimePasswordPage = () =>
  import('@/modules/auth/pages/OneTimePasswordPage.vue');
const LoginViaLinkPage = () =>
  import(
    /* webpackChunkName: 'auth' */ '@/modules/auth/pages/LoginViaLinkPage.vue'
  );

export const AuthRoutes: RouteConfig[] = [
  {
    path: '/auth',
    component: AuthModule,
    meta: {
      middlewares: {
        requiresValidBrowser: true,
        requiresGuest: true
      }
    },
    children: [
      {
        path: '/',
        name: 'auth',
        redirect: { name: 'auth.login' }
      },
      {
        path: 'login',
        name: 'auth.login',
        component: LoginPage,
        props: true
      },
      {
        path: 'login/:token',
        name: 'auth.linkLogin',
        component: LoginViaLinkPage,
        props: true
      },
      {
        path: 'two-factor-authentication',
        name: 'auth.twoFactorAuth',
        component: TwoFactorAuthPage,
        props: true
      },
      {
        path: 'one-time-password',
        name: 'auth.one-time-password',
        component: OneTimePasswordPage,
        props: true
      },
      {
        path: 'account/unlock/:token',
        name: 'auth.unlock.account',
        component: LoginPage
      },
      {
        path: 'signup/:invitation_code',
        name: 'auth.signup',
        component: SignupPage
      },
      {
        path: 'reset-password/:token',
        name: 'auth.reset-password',
        component: ResetPasswordPage,
        props: true
      },
      {
        path: 'forgot-password',
        name: 'auth.forgot-password',
        component: ForgotPasswordPage
      },
      {
        path: 'impersonation/:code',
        name: 'auth.impersonation',
        component: ImpersonationPage,
        props: true,
        meta: {
          disableTracking: true
        }
      }
    ]
  }
];
